import { IUser } from '@rhybus/api'

/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfAuthCrudHttp } from '../../../assets/ts/api/mpf-auth-crud-http'

interface UserArgs {
  isAscending?: boolean
  orderBy?: string
  search?: string
}

const COLUMN_NAMES = {
  CreatedBy: 'CreatedBy',
  CreatedOn: 'CreatedOn',
  ETag: 'ETag',
  Edipi: 'Edipi',
  Email: 'Email',
  FirstName: 'FirstName',
  IsDirty: 'IsDirty',
  LastLogin: 'LastLogin',
  LastName: 'LastName',
  ModifiedOn: 'ModifiedOn',
  ObjectId: 'ObjectId',
  RoleCodes: 'RoleCodes',
  Roles: 'Roles',
  TenantId: 'TenantId',
  UserId: 'UserId',
}
const LIST_NAME = 'Users'

const getUsers = async (args: UserArgs): Promise<IUser[]> => {
  const users = await mpfAuthCrudHttp().GetUsers(
    args?.search ? args.search : ''
  )

  return [...users] as IUser[]
}

export { COLUMN_NAMES, LIST_NAME, type UserArgs, getUsers }
